import React from "react";

function StatsTrustV1() {
  return (
    <section className="v1-stats-section">
      <div className="v1-stats-inner">
        {/* Stat 1 */}
        <div className="v1-stat-item">
          <svg
            className="v1-stat-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
          <div className="v1-stat-number">500+</div>
          <div className="v1-stat-label">Experiences worldwide</div>
        </div>

        {/* Stat 2 */}
        <div className="v1-stat-item">
          <svg
            className="v1-stat-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <div className="v1-stat-number">100K+</div>
          <div className="v1-stat-label">Happy travelers</div>
        </div>

        {/* Stat 3 */}
        <div className="v1-stat-item">
          <svg
            className="v1-stat-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
          <div className="v1-stat-number">4.8/5</div>
          <div className="v1-stat-label">Average rating</div>
        </div>

        {/* Stat 4 */}
        <div className="v1-stat-item">
          <svg
            className="v1-stat-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <polyline points="9 12 11 14 15 10" />
          </svg>
          <div className="v1-stat-number">Trusted</div>
          <div className="v1-stat-label">By global travelers</div>
        </div>
      </div>
    </section>
  );
}

export default StatsTrustV1;
